import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock, renderList as _renderList } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "admin-video-embed"
}
const _hoisted_2 = {
  key: 0,
  class: "empty-hint embed-pick-hint"
}
const _hoisted_3 = { class: "drop-zone-title" }
const _hoisted_4 = { class: "drop-zone-hint" }
const _hoisted_5 = {
  key: 0,
  class: "file-too-big"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = {
  key: 1,
  class: "upload-progress-text"
}
const _hoisted_9 = {
  key: 2,
  class: "upload-warning"
}
const _hoisted_10 = {
  key: 0,
  class: "info-hint"
}
const _hoisted_11 = {
  key: 1,
  class: "media-file-list"
}
const _hoisted_12 = { class: "media-file-main" }
const _hoisted_13 = { class: "media-file-title" }
const _hoisted_14 = { class: "media-file-meta" }
const _hoisted_15 = { class: "media-file-actions" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = {
  key: 2,
  class: "empty-hint"
}
const _hoisted_21 = { key: 0 }
const _hoisted_22 = {
  key: 1,
  class: "ion-text-wrap"
}
const _hoisted_23 = { class: "drop-zone-title" }
const _hoisted_24 = { class: "drop-zone-hint" }
const _hoisted_25 = {
  key: 0,
  class: "file-too-big"
}
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { key: 2 }
const _hoisted_28 = {
  key: 1,
  class: "upload-progress-text"
}
const _hoisted_29 = {
  key: 2,
  class: "upload-warning"
}
const _hoisted_30 = {
  key: 0,
  class: "info-hint"
}
const _hoisted_31 = {
  key: 1,
  class: "media-file-list"
}
const _hoisted_32 = { class: "media-file-main" }
const _hoisted_33 = { class: "media-file-title" }
const _hoisted_34 = { class: "media-file-meta" }
const _hoisted_35 = { class: "media-file-actions" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = ["onClick"]
const _hoisted_38 = ["onClick"]
const _hoisted_39 = ["onClick"]
const _hoisted_40 = {
  key: 2,
  class: "empty-hint"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_progress_bar = _resolveComponent("ion-progress-bar")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_PageHeaderWithMenu = _resolveComponent("PageHeaderWithMenu")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_ctx.embedMode)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!_ctx.lockedSectionKey)
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, "Выберите подраздел, чтобы загрузить или просмотреть видео."))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_ion_card, { class: "admin-card" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_card_header, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_card_title, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Загрузить видео в «" + _toDisplayString(_ctx.lockedSectionTitle) + "»", 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_card_content, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_input, {
                            label: "Название для пользователей",
                            "label-placement": "stacked",
                            modelValue: _ctx.uploadDisplayName,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.uploadDisplayName) = $event)),
                            placeholder: "Отображаемое название видео"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("input", {
                        type: "file",
                        ref: "fileInput",
                        accept: "video/*",
                        class: "file-input-hidden",
                        onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onFileSelected && _ctx.onFileSelected(...args)))
                      }, null, 544),
                      _createElementVNode("div", {
                        class: _normalizeClass(["drop-zone", { 'drop-zone--active': _ctx.videoDragOver, 'drop-zone--has-file': !!_ctx.selectedFile, 'drop-zone--disabled': _ctx.uploadInProgress }]),
                        onDragenter: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onVideoDragEnter && _ctx.onVideoDragEnter(...args)), ["prevent"])),
                        onDragover: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onVideoDragOver && _ctx.onVideoDragOver(...args)), ["prevent"])),
                        onDragleave: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onVideoDragLeave && _ctx.onVideoDragLeave(...args)), ["prevent"])),
                        onDrop: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onVideoDrop && _ctx.onVideoDrop(...args)), ["prevent"])),
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.pickVideoFile()))
                      }, [
                        _createVNode(_component_ion_icon, {
                          class: "drop-zone-icon",
                          icon: _ctx.cloudUploadOutline
                        }, null, 8, ["icon"]),
                        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.selectedFile ? _ctx.selectedFile.name : 'Перетащите видео сюда'), 1),
                        _createElementVNode("p", _hoisted_4, [
                          (_ctx.selectedFile)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(_ctx.formatBytes(_ctx.selectedFile.size)) + " ", 1),
                                (_ctx.diskSpace && _ctx.selectedFile.size > _ctx.diskSpace.availableBytes)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, " · недостаточно места"))
                                  : (_ctx.selectedFile.size > _ctx.LARGE_FILE_WARN_BYTES)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, " · чанковая загрузка"))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_7, " · нажмите, чтобы заменить"))
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode("или нажмите, чтобы выбрать файл")
                              ], 64))
                        ])
                      ], 34),
                      (_ctx.uploadInProgress)
                        ? (_openBlock(), _createBlock(_component_ion_progress_bar, {
                            key: 0,
                            value: _ctx.uploadProgressPercent / 100,
                            type: "determinate"
                          }, null, 8, ["value"]))
                        : _createCommentVNode("", true),
                      (_ctx.uploadInProgress)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.uploadProgressPercent) + "%", 1))
                        : _createCommentVNode("", true),
                      (_ctx.uploadInProgress)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_9, "⚠️ Не закрывайте окно до завершения загрузки."))
                        : _createCommentVNode("", true),
                      _createVNode(_component_ion_button, {
                        expand: "block",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.doUpload())),
                        disabled: !_ctx.canUpload || _ctx.uploadInProgress
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.uploadInProgress ? 'Загрузка…' : 'Загрузить на сервер'), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_card, { class: "admin-card" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_card_header, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_card_title, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Видео «" + _toDisplayString(_ctx.lockedSectionTitle) + "»", 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_card_content, null, {
                    default: _withCtx(() => [
                      (_ctx.hasProcessingVideos)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_10, "ℹ️ Конвертация видео идёт на сервере. Можно закрыть окно и вернуться позднее — прогресс обновится автоматически."))
                        : _createCommentVNode("", true),
                      (_ctx.videos.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.videos, (v) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: v.id,
                                class: "media-file-row"
                              }, [
                                _createElementVNode("div", _hoisted_12, [
                                  _createElementVNode("div", _hoisted_13, _toDisplayString(v.displayName), 1),
                                  _createElementVNode("div", _hoisted_14, _toDisplayString(v.sourceType), 1),
                                  (_ctx.isProcessingWithProgress(v))
                                    ? (_openBlock(), _createBlock(_component_ion_progress_bar, {
                                        key: 0,
                                        value: (_ctx.conversionProgress[Number(v.id)]?.percent ?? 0) / 100,
                                        type: "determinate",
                                        class: "conversion-progress"
                                      }, null, 8, ["value"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("span", {
                                  class: _normalizeClass(["media-status", 'media-status--' + _ctx.effectiveStatus(v)])
                                }, _toDisplayString(_ctx.effectiveStatusLabel(v)), 3),
                                _createElementVNode("div", _hoisted_15, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "media-icon-btn",
                                    onClick: ($event: any) => (_ctx.renameVideo(v)),
                                    title: "Переименовать"
                                  }, [
                                    _createVNode(_component_ion_icon, { icon: _ctx.pencilOutline }, null, 8, ["icon"])
                                  ], 8, _hoisted_16),
                                  (v.status === 'PROCESSING')
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        type: "button",
                                        class: "media-icon-btn",
                                        onClick: ($event: any) => (_ctx.cancelConversion(v)),
                                        title: "Остановить"
                                      }, [
                                        _createVNode(_component_ion_icon, { icon: _ctx.stopCircleOutline }, null, 8, ["icon"])
                                      ], 8, _hoisted_17))
                                    : _createCommentVNode("", true),
                                  (v.status === 'FAILED' || v.status === 'CANCELLED')
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        type: "button",
                                        class: "media-icon-btn",
                                        onClick: ($event: any) => (_ctx.retryConversion(v)),
                                        title: "Повторить"
                                      }, [
                                        _createVNode(_component_ion_icon, { icon: _ctx.refreshOutline }, null, 8, ["icon"])
                                      ], 8, _hoisted_18))
                                    : _createCommentVNode("", true),
                                  (v.status === 'READY' || v.status === 'FAILED' || v.status === 'CANCELLED')
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 2,
                                        type: "button",
                                        class: "media-icon-btn media-icon-btn--danger",
                                        onClick: ($event: any) => (_ctx.deleteVideo(v)),
                                        title: "Удалить"
                                      }, [
                                        _createVNode(_component_ion_icon, { icon: _ctx.trashOutline }, null, 8, ["icon"])
                                      ], 8, _hoisted_19))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            }), 128))
                          ]))
                        : (_openBlock(), _createElementBlock("p", _hoisted_20, "Нет видео в этом подразделе."))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ], 64))
      ]))
    : (_openBlock(), _createBlock(_component_ion_page, { key: 1 }, {
        default: _withCtx(() => [
          _createVNode(_component_PageHeaderWithMenu, {
            title: "Загрузка видео",
            scrolled: _ctx.headerScrolled
          }, null, 8, ["scrolled"]),
          _createVNode(_component_ion_content, {
            class: _normalizeClass([_ctx.isMobile ? 'main-background' : 'liga-web-background']),
            fullscreen: true,
            onIonScroll: _ctx.onContentScroll
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_card, { class: "admin-card disk-card" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_card_header, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_card_title, null, {
                        default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                          _createTextVNode("Место на сервере", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_card_content, null, {
                    default: _withCtx(() => [
                      (_ctx.diskSpace)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_21, "Свободно: " + _toDisplayString(_ctx.formatBytes(_ctx.diskSpace.availableBytes)) + " из " + _toDisplayString(_ctx.formatBytes(_ctx.diskSpace.totalBytes)), 1))
                        : (_openBlock(), _createElementBlock("p", _hoisted_22, "Загрузка данных о месте…"))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_card, { class: "admin-card" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_card_header, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_card_title, null, {
                        default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                          _createTextVNode("Загрузить видео", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_card_content, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_select, {
                            label: "Подраздел медиатеки",
                            "label-placement": "stacked",
                            modelValue: _ctx.uploadSectionKey,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.uploadSectionKey) = $event)),
                            interface: "popover",
                            mode: "ios",
                            placeholder: "Выберите раздел"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.educationSections, (s) => {
                                return (_openBlock(), _createBlock(_component_ion_select_option, {
                                  key: s.id || s.folderKey,
                                  value: s.folderKey
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(s.name) + " (" + _toDisplayString(s.folderKey) + ")", 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_input, {
                            label: "Название для пользователей",
                            "label-placement": "stacked",
                            modelValue: _ctx.uploadDisplayName,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.uploadDisplayName) = $event)),
                            placeholder: "Отображаемое название видео"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("input", {
                        type: "file",
                        ref: "fileInput",
                        accept: "video/*",
                        class: "file-input-hidden",
                        onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.onFileSelected && _ctx.onFileSelected(...args)))
                      }, null, 544),
                      _createElementVNode("div", {
                        class: _normalizeClass(["drop-zone", { 'drop-zone--active': _ctx.videoDragOver, 'drop-zone--has-file': !!_ctx.selectedFile, 'drop-zone--disabled': _ctx.uploadInProgress }]),
                        onDragenter: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onVideoDragEnter && _ctx.onVideoDragEnter(...args)), ["prevent"])),
                        onDragover: _cache[12] || (_cache[12] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onVideoDragOver && _ctx.onVideoDragOver(...args)), ["prevent"])),
                        onDragleave: _cache[13] || (_cache[13] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onVideoDragLeave && _ctx.onVideoDragLeave(...args)), ["prevent"])),
                        onDrop: _cache[14] || (_cache[14] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onVideoDrop && _ctx.onVideoDrop(...args)), ["prevent"])),
                        onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.pickVideoFile()))
                      }, [
                        _createVNode(_component_ion_icon, {
                          class: "drop-zone-icon",
                          icon: _ctx.cloudUploadOutline
                        }, null, 8, ["icon"]),
                        _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.selectedFile ? _ctx.selectedFile.name : 'Перетащите видео сюда'), 1),
                        _createElementVNode("p", _hoisted_24, [
                          (_ctx.selectedFile)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(_ctx.formatBytes(_ctx.selectedFile.size)) + " ", 1),
                                (_ctx.diskSpace && _ctx.selectedFile.size > _ctx.diskSpace.availableBytes)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_25, " · недостаточно места"))
                                  : (_ctx.selectedFile.size > _ctx.LARGE_FILE_WARN_BYTES)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_26, " · чанковая загрузка"))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_27, " · нажмите, чтобы заменить"))
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode("или нажмите, чтобы выбрать файл")
                              ], 64))
                        ])
                      ], 34),
                      (_ctx.uploadInProgress)
                        ? (_openBlock(), _createBlock(_component_ion_progress_bar, {
                            key: 0,
                            value: _ctx.uploadProgressPercent / 100,
                            type: "determinate"
                          }, null, 8, ["value"]))
                        : _createCommentVNode("", true),
                      (_ctx.uploadInProgress)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_28, _toDisplayString(_ctx.uploadProgressPercent) + "%", 1))
                        : _createCommentVNode("", true),
                      (_ctx.uploadInProgress)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_29, "⚠️ Не закрывайте окно до завершения загрузки."))
                        : _createCommentVNode("", true),
                      _createVNode(_component_ion_button, {
                        expand: "block",
                        onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.doUpload())),
                        disabled: !_ctx.canUpload || _ctx.uploadInProgress
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.uploadInProgress ? 'Загрузка…' : 'Загрузить на сервер'), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_card, { class: "admin-card" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_card_header, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_card_title, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Видео раздела «" + _toDisplayString(_ctx.mediaCategoryTitle) + "»", 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_card_content, null, {
                    default: _withCtx(() => [
                      (_ctx.hasProcessingVideos)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_30, "ℹ️ Конвертация видео идёт на сервере. Можно закрыть окно и вернуться позднее — прогресс обновится автоматически."))
                        : _createCommentVNode("", true),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_select, {
                            label: "Раздел",
                            "label-placement": "stacked",
                            modelValue: _ctx.filterSectionKey,
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.filterSectionKey) = $event)),
                            interface: "popover",
                            mode: "ios",
                            onIonChange: _cache[18] || (_cache[18] = ($event: any) => (_ctx.loadVideos()))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_select_option, { value: "" }, {
                                default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                                  _createTextVNode("Все разделы", -1)
                                ]))]),
                                _: 1
                              }),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.educationSections, (s) => {
                                return (_openBlock(), _createBlock(_component_ion_select_option, {
                                  key: s.id || s.folderKey,
                                  value: s.folderKey
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(s.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      (_ctx.videos.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.videos, (v) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: v.id,
                                class: "media-file-row"
                              }, [
                                _createElementVNode("div", _hoisted_32, [
                                  _createElementVNode("div", _hoisted_33, _toDisplayString(v.displayName), 1),
                                  _createElementVNode("div", _hoisted_34, _toDisplayString(v.sectionName || v.sectionFolderKey) + " · " + _toDisplayString(v.sourceType), 1),
                                  (_ctx.isProcessingWithProgress(v))
                                    ? (_openBlock(), _createBlock(_component_ion_progress_bar, {
                                        key: 0,
                                        value: (_ctx.conversionProgress[Number(v.id)]?.percent ?? 0) / 100,
                                        type: "determinate",
                                        class: "conversion-progress"
                                      }, null, 8, ["value"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("span", {
                                  class: _normalizeClass(["media-status", 'media-status--' + _ctx.effectiveStatus(v)])
                                }, _toDisplayString(_ctx.effectiveStatusLabel(v)), 3),
                                _createElementVNode("div", _hoisted_35, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "media-icon-btn",
                                    onClick: ($event: any) => (_ctx.renameVideo(v)),
                                    title: "Переименовать"
                                  }, [
                                    _createVNode(_component_ion_icon, { icon: _ctx.pencilOutline }, null, 8, ["icon"])
                                  ], 8, _hoisted_36),
                                  (v.status === 'PROCESSING')
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        type: "button",
                                        class: "media-icon-btn",
                                        onClick: ($event: any) => (_ctx.cancelConversion(v)),
                                        title: "Остановить"
                                      }, [
                                        _createVNode(_component_ion_icon, { icon: _ctx.stopCircleOutline }, null, 8, ["icon"])
                                      ], 8, _hoisted_37))
                                    : _createCommentVNode("", true),
                                  (v.status === 'FAILED' || v.status === 'CANCELLED')
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        type: "button",
                                        class: "media-icon-btn",
                                        onClick: ($event: any) => (_ctx.retryConversion(v)),
                                        title: "Повторить"
                                      }, [
                                        _createVNode(_component_ion_icon, { icon: _ctx.refreshOutline }, null, 8, ["icon"])
                                      ], 8, _hoisted_38))
                                    : _createCommentVNode("", true),
                                  (v.status === 'READY' || v.status === 'FAILED' || v.status === 'CANCELLED')
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 2,
                                        type: "button",
                                        class: "media-icon-btn media-icon-btn--danger",
                                        onClick: ($event: any) => (_ctx.deleteVideo(v)),
                                        title: "Удалить"
                                      }, [
                                        _createVNode(_component_ion_icon, { icon: _ctx.trashOutline }, null, 8, ["icon"])
                                      ], 8, _hoisted_39))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            }), 128))
                          ]))
                        : (_openBlock(), _createElementBlock("p", _hoisted_40, "Нет видео или загрузка не реализована."))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["class", "onIonScroll"])
        ]),
        _: 1
      }))
}